import { Text, Button, Box } from "grommet";
import React, { ReactNode, useCallback } from "react";
import CustomCard from "../../../../../common/card/CustomCard";
import "./ReportButton.css";
import StandardColors from "../../../../../../../../util/StandardColors";
import reuploadReport from '../../../../../../../../assets/reUpload.svg';
import { useStore } from "../../../../../../../../Hooks/useStore";
import { useUser } from "../../../../../../context/User/UserContext";
import { NotificationHelper } from "../../../../../../../../util/notification/NotificationHelper";
import { MedicalEmergencyHelper } from "../../../../../../../../util/medical-emergency/MedicalEmergencyHelper";
import { subscribeToTopic ,unsubscribeToTopic,sendDataToTopic} from "../../../../../../../../App";
import { Autoupdateenum } from "../../../../../../../../enums";
import MedicalEmergencyService from "../../../../../../../../services/medical-emergency/medical-emergency.service";
import { useParams } from "react-router-dom";

type ReportButtonProp = {
  alt: string;
  imageName: string;
  title: string;
  onClick: () => void;
  reportLength: boolean;
  bgColor: string;
  passenger: string;
  mCrew: string;
  reportType: string;
  isDisable: boolean;
};

function ReportButton({ alt, imageName, title, onClick, reportLength, bgColor, passenger, mCrew, reportType, isDisable }: ReportButtonProp) {
  const { rootStore } = useStore();
  const { user } = useUser();
  const { medicalEmergencyId } = useParams();

  const notifyUsers = useCallback(
    async (emergencyname: string, msg: string) => {
      if (!user || !rootStore.emsStore.getSelectedEmergency) return;
      const notificationHelper = new NotificationHelper();
      const medicalEmergencyHelper = new MedicalEmergencyHelper();
      let users = [];
      let cognitoUserId = null;
      if (user["custom:type"] === "ems") {
        cognitoUserId = await medicalEmergencyHelper.findCrew(
          rootStore.emsStore.getSelectedEmergency.id
        );
      }
      if (cognitoUserId) {
        users.push(cognitoUserId);
      }
      if (users.length != 0) {
        notificationHelper.sendNotification(emergencyname, msg, users);
      }
    },
    [rootStore.emsStore.getSelectedEmergency, user]
  );

  const requestReport = async (passengerName: string, reportTitle: string, crew: string) => {
    try {
      console.log("medicalEmergencyId"+medicalEmergencyId)
      if (medicalEmergencyId != undefined) {
        await MedicalEmergencyService.requestToReportUpload(medicalEmergencyId,reportType);
      }
    } catch(error) {
      console.log(error);
    }
    let msg = reportTitle;
    notifyUsers(passengerName, msg);
    rootStore.successStore.showNotification(msg, crew, "report", 3000);
  
    sendDataToTopic(rootStore.emsStore.getSelectedEmergency?.id,rootStore.emsStore.getSelectedEmergency?.flightId,Autoupdateenum.VitalRequested);
  }
  const reUploadReport = async (passengerName: string, reportTitle: string, crew: string) => {
    try {
      console.log("medicalEmergencyId"+medicalEmergencyId)
      if (medicalEmergencyId != undefined) {
        await MedicalEmergencyService.requestToReportUpload(medicalEmergencyId,reportType);
      }
    } catch(error) {
      console.log(error);
    }
    let msg = reportTitle;
    notifyUsers(passengerName, msg);
    rootStore.successStore.showNotification(msg, crew, "report", 3000);
    sendDataToTopic(rootStore.emsStore.getSelectedEmergency?.id,rootStore.emsStore.getSelectedEmergency?.flightId,Autoupdateenum.VitalRequested);
  }
  return (
    <CustomCard
      containerStyle={{
        alignItems: "center",
        width: rootStore.emsStore.getSeeAll ? "50%" : 'auto',
        boxShadow: 'unset'
      }}
      className="report-button"
    >
      <Box style={{backgroundColor: bgColor}} className={rootStore.emsStore.getSeeAll ? "report-image-shape report-image-shape-active" : "report-image-shape"}>
        <img
          src={require("../../../../../../../../assets/" + imageName)}
          style={{ width: 25 }}
          alt={alt}
        />
      </Box>
      <div className="report-button-text">{title}</div>
      {
        reportLength
        ?
        <>
          <Button className="report-view-button" onClick={onClick}>View Report</Button>
          <Box className="reupload-report" style={{opacity: isDisable ? 0.6 : 1,cursor: isDisable ? 'not-allowed' : "pointer",pointerEvents: isDisable ? "none" : "auto"}} onClick={() => reUploadReport(passenger, title, mCrew)}>
            <img
              src={reuploadReport}
              style={{ width: 16 }}
              alt="Re upload report"
            />
            <Text className="reupload-txt">Re-upload</Text>
          </Box>
        </>
        :
        <>
          <Button className="dashed-txt">----</Button>
          <Box className="reupload-report" style={{opacity: isDisable ? 0.6 : 1,cursor: isDisable ? 'not-allowed' : "pointer",pointerEvents: isDisable ? "none" : "auto"}} onClick={() => requestReport(passenger, title, mCrew)}>
            <img
              src={reuploadReport}
              style={{ width: 16 }}
              alt="Re upload report"
            />
            <Text className="reupload-txt">Request report</Text>
          </Box>
        </>
      }
      {/* <Button className="report-view-button" onClick={onClick} style={{backgroundColor: reportLength ? StandardColors.primary_blue_100 : 'rgb(0,0,0)'}} disabled={reportLength ? false : true}>View Report</Button> */}
      {/* <span id="reportIndicator" style={{width: 10,height: 10,borderRadius: 100,display: reportLength ? 'block' : 'none',marginLeft: 5,backgroundColor: "red",position: 'absolute',left: 3,bottom: 3}} className="indicator"></span> */}
      
    </CustomCard>
  );
}

export default ReportButton;
